import { render, staticRenderFns } from "./NotificationDropDownListItem.vue?vue&type=template&id=27500ff5&scoped=true&"
import script from "./NotificationDropDownListItem.vue?vue&type=script&lang=js&"
export * from "./NotificationDropDownListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27500ff5",
  null
  
)

export default component.exports